"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _HorizontalDivider = _interopRequireDefault(require("../../elements/horizontal-divider/Horizontal-Divider"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _Stat = _interopRequireDefault(require("../../molecules/Stat/Stat"));
var _HorizontalStat = _interopRequireDefault(require("../../molecules/HorizontalStat/HorizontalStat"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _ThreeColumnLayout = _interopRequireDefault(require("../../layouts/ThreeColumnLayout/ThreeColumnLayout"));
var _TwelveColumnGrid = _interopRequireDefault(require("../../components/Grid/TwelveColumnGrid/TwelveColumnGrid"));
var _TwoColumnLayout = _interopRequireDefault(require("../../layouts/TwoColumnLayout/TwoColumnLayout"));
var _excluded = ["headingCopy", "subheadingCopy", "image1Url", "image2Url", "image3Url", "text1", "text2", "text3"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var HowItWorksImageLeft = _styledComponents.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\ndisplay: flex;\nalign-items: flex-start;\nmax-width: 100%;\nheight: auto;\nmargin-left: -100px !important;\nmargin-right: 0px;\nmargin-top: 20px\nmargin-bottom: 30px;\n\n@media (min-width: ", ") {\n  margin-left: -100px !important;\n  margin-top: 20px;\n  margin-bottom: 30px;\n  text-align: left;\n}\n\n@media (min-width: ", ") {\n  max-height: unset;\n  margin-top: 20px;\n  margin-left: -100px !important;\n  margin-bottom: 30px;\n}\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var HowItWorksImageRight = _styledComponents.default.img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\nmax-width: 100%;\n\nmargin-right:  -100px !important;\nmargin-bottom: 20px;\n\n@media (min-width: ", ") {\n  max-height: 60vh;\n  margin-right:  -100px !important;\n  margin-bottom: 25px;\n  text-align: left;\n}\n\n@media (min-width: ", ") {\n  max-height: unset;\n  margin-right:  -100px !important;\n  margin-bottom: 30px;\n}\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var HowItWorksImageCenter = _styledComponents.default.img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\nmax-width: 100%;\nmargin-bottom: 20px;\n\n@media (min-width: ", ") {\n  max-height: 60vh;\n  margin-bottom: 25px;\n  text-align: left;\n}\n\n@media (min-width: ", ") {\n  max-height: unset;\n  margin-bottom: 30px;\n}\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    bold: true,
    className: className
  }, " ", children, " ");
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    text-align: center;\n  "])));
var StyledSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    Heading: true,
    h5: true,
    darkGrey: true,
    className: className
  }, " ", children, " ");
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\ndisplay: flex;\nalign-items: flex-start;\ntext-align: left;\nmargin-top: 10px;\nmargin-bottom: 10px;\n"])));
var StyledParagraph = (0, _styledComponents.default)(_Paragraph.default)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\ntext-align: left;\nmargin-bottom: 30px;\ndisplay: flex;\nalign-items: flex-start;\ncolor: var(--bf-core-gray);\n"])));
var StyledIntroParagraph = (0, _styledComponents.default)(_Paragraph.default)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\ntext-align: center;\nmargin-bottom: 30px;\ncolor: var(--bf-core-darkGrey);\n"])));
var StyledPageGrid = (0, _styledComponents.default)(_PageGrid.default)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)([" \n  text-align: center;\n  border-top: transparent;\n  border-bottom: transparent;\n  border-left: transparent;\n  border-left-width: 0px !important;\n  border-right: transparent;\n  border-right-width: 0px !important;\n"])));
var HowItWorksPartners = function HowItWorksPartners(_ref3) {
  var headingCopy = _ref3.headingCopy,
    subheadingCopy = _ref3.subheadingCopy,
    image1Url = _ref3.image1Url,
    image2Url = _ref3.image2Url,
    image3Url = _ref3.image3Url,
    text1 = _ref3.text1,
    text2 = _ref3.text2,
    text3 = _ref3.text3,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(StyledPageGrid, null, _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    justifyContent: "center",
    style: {
      textAlign: 'center'
    }
  }, props), _react.default.createElement(StyledHeading, Object.assign({
    xs: 12
  }, props), headingCopy), _react.default.createElement(StyledIntroParagraph, {
    gray: true,
    s: true
  }, " ", subheadingCopy, " ")), _react.default.createElement(_TwoColumnLayout.default, Object.assign({
    variant: "SixSixRatio"
  }, props), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'block',
        xs: 'none',
        sm: 'none',
        md: 'block',
        lg: 'block'
      }
    },
    xs: 12,
    sm: 12,
    md: 8,
    lg: 8
  }, _react.default.createElement(HowItWorksImageLeft, {
    class: "full-width",
    xs: 6,
    src: image1Url
  })), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'none',
        xs: 'block',
        sm: 'block',
        md: 'none',
        lg: 'none'
      }
    },
    xs: 12,
    sm: 12,
    md: 8,
    lg: 8
  }, _react.default.createElement(HowItWorksImageCenter, {
    src: image2Url
  })), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, _react.default.createElement(StyledSubheading, {
    h4: true,
    darkGrey: true,
    xs: 5
  }, " ", text1.header, " "), _react.default.createElement(StyledParagraph, {
    gray: true
  }, " ", text1.body)), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'block',
        xs: 'none',
        sm: 'none',
        md: 'block',
        lg: 'block'
      }
    },
    justifyContent: "flex-end",
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, _react.default.createElement(StyledSubheading, {
    h4: true,
    darkGrey: true
  }, " ", text2.header, " "), _react.default.createElement(StyledParagraph, {
    gray: true,
    m: true
  }, " ", text2.body)), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'block',
        xs: 'none',
        sm: 'none',
        md: 'block',
        lg: 'block'
      }
    },
    xs: 12,
    sm: 12,
    md: 8,
    lg: 8
  }, _react.default.createElement(HowItWorksImageRight, {
    src: image2Url
  })), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'none',
        xs: 'block',
        sm: 'block',
        md: 'none',
        lg: 'none'
      }
    },
    xs: 12,
    sm: 12,
    md: 8,
    lg: 8
  }, _react.default.createElement(HowItWorksImageCenter, {
    src: image2Url
  })), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'none',
        xs: 'block',
        sm: 'block',
        md: 'none',
        lg: 'none'
      }
    },
    justifyContent: "flex-end",
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, _react.default.createElement(StyledSubheading, null, " ", text2.header, " "), _react.default.createElement(StyledParagraph, {
    gray: true,
    m: true
  }, " ", text2.body)), _react.default.createElement(_Grid.default, {
    xs: 12,
    sm: 12,
    md: 8,
    lg: 8,
    sx: {
      display: {
        xl: 'block',
        xs: 'none',
        sm: 'none',
        md: 'block',
        lg: 'block'
      }
    }
  }, _react.default.createElement(HowItWorksImageLeft, {
    src: image3Url
  })), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'none',
        xs: 'block',
        sm: 'block',
        md: 'none',
        lg: 'none'
      }
    },
    xs: 12,
    sm: 12,
    md: 8,
    lg: 8
  }, _react.default.createElement(HowItWorksImageCenter, {
    src: image2Url
  })), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, _react.default.createElement(StyledSubheading, {
    h4: true
  }, " ", text3.header, " "), _react.default.createElement(StyledParagraph, {
    gray: true
  }, " ", text1.body))));
};
var _default = HowItWorksPartners;
exports.default = _default;